/**
 * PROJECTS詳細ページの表示
 */

import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';
import PageTransition from '../common/PageTransition';
import projectsKV from '../projects/projectsKV';

export default class projectsShowEntry {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'projectsShowEntry';
    this.isStart = false;
    this.openObject = [];
    this.scrollObject = [];

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    this.projectsKV = new projectsKV();

    this.PageTransition = new PageTransition();

    // 文章エリア
    document.getElementById('l-projects-content')
      .querySelectorAll('.l-projects-content__col').forEach((el, i) => {

      TweenMax.set(el, {opacity: 0, y: '20%'});

      this.openObject.push({
        el: el,
        delay: 0
      });
    });

    // 画像エリア
    document.getElementById('l-projects-picture')
      .querySelectorAll('.l-projects-picture__col').forEach((el, i) => {

      TweenMax.set(el, {className: '+=is-hide'});

      this.scrollObject.push({
        el: el,
        delay: 0,
        isShow: false
      });
    });

    // クライアントエリア
    const elClients = document.getElementById('l-projects-clients');
    if (elClients) {
      TweenMax.set(elClients, {className: '+=is-hide'});

      this.scrollObject.push({
        el: elClients,
        delay: 0,
        isShow: false
      });
    }

    // ページナビエリア
    TweenMax.set(document.getElementById('l-projects-nav'), {className: '+=is-hide'});
    this.scrollObject.push({
      el: document.getElementById('l-projects-nav'),
      delay: 0,
      isShow: false
    });

    // domの最大数
    this.max = this.scrollObject.length;

    // トランジション時のコールバック
    // start
    this.PageTransition.on('TRANSITION_OUT',  this.transitionOut.bind(this));
    // next
    this.PageTransition.on('TRANSITION_IN', this.transitionIn.bind(this));

    // イベント
    this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {
    // 前面のレイヤーを上に移動する
    this.PageTransition.transitionOut();
  }

  /**
   * 表示アニメ
   */
  transitionOut() {
    this.projectsKV.start();

    TweenMax.to(this.openObject[0].el, 1.0, {
      delay: 0.2,
      y: '0%',
      opacity: 1,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.openObject[1].el, 1.0, {
      delay: 0.3,
      y: '0%',
      opacity: 1,
      ease: Cubic.easeOut,
      onComplete: this.transitionOutComp.bind(this)
    });
  }

  transitionOutComp() {
    this.isStart = true;
    this.resizeUpdate();
  }

  /**
   * 非表示時アニメ
   */
  transitionIn() {

  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    if (!this.isStart) return;

    let isFinish = true;
    const posY = _scrollY + (window.innerHeight * 0.75);

    for (let i = 0; i < this.max; i++) {
      if (this.scrollObject[i].isShow) continue;

      isFinish = false;
      if (posY > AnyStore.getOffsetTop(this.scrollObject[i].el).top) {
        this.scrollObject[i].isShow = true;
        TweenMax.set(this.scrollObject[i].el, {className: '-=is-hide'});

        // 表示済みなので削除
        this.scrollObject.splice(i, 1);
        this.max = this.scrollObject.length;
        i--;
      }
    }

    if (isFinish) {
      // 全部表示した
      this.destroy();
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  /**
   * 削除
   */
  destroy() {
    this.openObject = [];
    this.scrollObject = [];
    ResizeWatch.cancelObserver(this.name);
    ScrollWatch.cancelObserver(this.name);
  }
}
